import type { FieldInputProps } from 'formik';

import { FormControl, FormLabel, Input } from '@frontend/components';

type ErpFieldProps = {
  isSubmitting: boolean;
  field: FieldInputProps<string>;
};

export const ErpField = ({ isSubmitting, field }: ErpFieldProps) => {
  return (
    <FormControl isReadOnly={isSubmitting}>
      <FormLabel>Erp Code</FormLabel>
      <Input {...field} aria-label="ERP Code" />
    </FormControl>
  );
};
